// eslint-disable-next-line
export const LOCALE_PREFIX = 'scenes.Gnosus.components.Ribbon.components.ButtonsControls'
